"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material/");
require("../../scss/_button.scss");
var material_2 = require("@mui/material/");
/**
 * @component Button
 * @example
 * return (
 *   <Button
 *      type="primary"
 *      isSubmitButton
 *      onClick={() => {}}
 *   >
 *     Button text
 *   </Button>
 * )
 *
 * @param {string} type one of "primary", "secondary", "danger", "text"
 * @param {function} onClick func for what happens when you click the button
 * @param {boolean} isSubmitButton changes button type to a 'submit' button
 * @param {boolean} disabled toggles if the button is disabled
 * @param {boolean} fullWidth unlocks the width of the button
 * @param {Element} icon pass a MUI icon to show on the button
 * @param {any} errors any errors from the form
 * @param {number} marginTop margin on the top of the button
 * @param {number} marginRight margin on the right of the button
 * @param {number} marginBottom margin on the bottom of the button
 * @param {number} marginLeft margin on the left of the button
 * @param {number} paddingRight padding on the right of the button
 * @param {number} spinnerLeftPosition in rems - use to move the spinner so that it's not off center in extra wide or narrow buttons.
 * @param {string} children the button text
 * @param {boolean} loading boolean for whether a loading spinner will show.
 * @param {any} style applied to the button
 */
var Button = function (props) {
    var type = props.type, onClick = props.onClick, _a = props.isSubmitButton, isSubmitButton = _a === void 0 ? false : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.fullWidth, fullWidth = _c === void 0 ? false : _c, icon = props.icon, _d = props.marginTop, marginTop = _d === void 0 ? 0 : _d, _e = props.marginRight, marginRight = _e === void 0 ? 0 : _e, _f = props.marginBottom, marginBottom = _f === void 0 ? 0 : _f, _g = props.marginLeft, marginLeft = _g === void 0 ? 0 : _g, _h = props.paddingLeft, paddingLeft = _h === void 0 ? 8 : _h, _j = props.paddingRight, paddingRight = _j === void 0 ? 8 : _j, _k = props.spinnerLeftPosition, spinnerLeftPosition = _k === void 0 ? 4 : _k, text = props.children, _l = props.loading, loading = _l === void 0 ? false : _l, style = props.style, _m = props["test-id"], testId = _m === void 0 ? "" : _m;
    function handleClick() {
        if (onClick) {
            onClick();
        }
    }
    var buttonType = isSubmitButton ? "submit" : "button";
    var buttonMargins = "mt-".concat(marginTop, " mr-").concat(marginRight, " mb-").concat(marginBottom, " ml-").concat(marginLeft);
    var buttonPaddings = "pr-".concat(paddingRight, " pl-").concat(paddingLeft);
    var button = (react_1.default.createElement(material_1.Button, { onClick: handleClick, type: buttonType, className: "primary-btn ".concat(buttonMargins, " ").concat(buttonPaddings), variant: "contained", color: "primary", disabled: disabled || loading, disableRipple: true, fullWidth: fullWidth, style: style, "test-id": testId }, text));
    switch (type) {
        case "primary":
            button = (react_1.default.createElement(material_1.Button, { onClick: handleClick, type: buttonType, className: "primary-btn ".concat(buttonMargins, " ").concat(buttonPaddings), variant: "contained", color: "primary", disabled: disabled, disableRipple: true, style: style, "test-id": testId }, text));
            break;
        case "secondary":
            button = (react_1.default.createElement(material_1.Button, { onClick: handleClick, type: buttonType, className: "outlined secondary-btn ".concat(buttonMargins, " ").concat(buttonPaddings), variant: "outlined", color: "primary", disabled: disabled, disableRipple: true, style: style, "test-id": testId }, text));
            break;
        case "danger":
            button = (react_1.default.createElement(material_1.Button, { onClick: handleClick, type: buttonType, className: "outlined danger-btn ".concat(buttonMargins, " ").concat(buttonPaddings), variant: "outlined", disabled: disabled, disableRipple: true, style: style, "test-id": testId }, text));
            break;
        case "text":
            button = (react_1.default.createElement("button", { onClick: handleClick, type: buttonType, className: "text-btn ".concat(buttonMargins, " ").concat(buttonPaddings), disabled: disabled, style: style },
                react_1.default.createElement("span", { className: "mr-2" }, icon),
                react_1.default.createElement("span", { className: "label" }, text)));
            break;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: "button" },
            button,
            loading && (react_1.default.createElement(material_2.CircularProgress, { size: 24, className: "progress", style: { left: spinnerLeftPosition + 'rem' } })))));
};
exports.default = Button;
